import React from "react";
import { Star, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function TheMasonryRevolution() {
  return <section data-section-id="255405" id="the-masonry-revolution" className="relative min-h-screen flex flex-col items-center justify-center py-24 px-4 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-muted/50 to-background z-0"></div>

      <div className="relative z-10 flex flex-col items-center max-w-4xl mx-auto text-center">
        {}
        <div className="mb-6 animate-pulse">
          <Star className="w-10 h-10 text-primary fill-primary" style={{
          filter: "drop-shadow(0 0 15px rgba(37, 99, 235, 0.4))"
        }} />
        </div>

        {}
        <h1 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold text-foreground tracking-tight mb-4 uppercase" style={{
        textShadow: "0 0 2px rgba(0,0,0,0.1)"
      }}>
          The Masonry Revolution
        </h1>

        {}
        <p className="font-default italic text-xl md:text-2xl text-muted-foreground mb-12">
          Speed without Compromise
        </p>

        {}
        <div className="relative w-64 h-64 md:w-80 md:h-80 mb-12 flex items-center justify-center">
          {}
          <div className="absolute inset-0 bg-primary/10 blur-[60px] rounded-lg"></div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_panel_system.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_panel_system.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_panel_system.png-wvc-sizes" alt="ClifRock Masonry Technology" className="relative z-10 w-full h-full object-contain drop-shadow-xl rounded-lg" loading="lazy" />
        </div>

        {}
        <div className="flex flex-col gap-6 text-muted-foreground font-default italic text-lg mb-10">
          <div className="flex items-center justify-center gap-3">
            <BookOpen className="w-5 h-5 text-primary/60" />
            <span>Traditional Masonry vs. ClifRock Panels</span>
          </div>
          <div className="flex items-center justify-center gap-3">
            <BookOpen className="w-5 h-5 text-primary/60" />
            <span>Build Faster with Less Labor</span>
          </div>
        </div>

        {}
        <div className="font-default text-foreground/80 text-lg md:text-xl space-y-2 mb-12">
          <p>Engineered for the modern contractor.</p>
          <p className="text-primary font-semibold italic">The future of outdoor living.</p>
        </div>

        {}
        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg h-auto py-4 px-8 text-lg md:text-xl flex items-center gap-3 group shadow-lg transition-all">
          <Star className="w-5 h-5 fill-current transition-transform group-hover:rotate-45" />
          Become a ClifRock Installer
        </Button>

        {}
        <p className="text-sm text-muted-foreground/60 mt-8 font-default tracking-wide">
          Join the network of elite hardscape professionals
        </p>
      </div>
    </section>;
}